export const validationKeys = {
    all: ['validation'],
    files: () => ['validation', 'files'],
    file: (id) => ['validation', 'file', id],
    solution: (fileId, solutionId) => ['validation', 'solution', fileId, solutionId],
    config: () => ['validation', 'config'],
    blob: (key) => ['validation', 'blob', key]
};
